"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatEventsHelper = void 0;
const events_1 = require("@front/event/events");
const ChatAudioHelper_1 = require("./ChatAudioHelper");
const translations_1 = require("@front/application/globals/translations");
const component_1 = require("@front/layouts/default-layout/component");
const conversation_agent_events_1 = require("../../../../../common/constants/conversation-agent-events");
class ChatEventsHelper {
    static bindEvents() {
        var _a;
        this.addEventListener('websearch-change', (e) => {
            const detail = e.detail;
            this.handleWebSearchChange(detail === null || detail === void 0 ? void 0 : detail.checked);
        });
        this.addEventListener('deepsearch-change', (e) => {
            const detail = e.detail;
            this.handleDeepSearchChange(detail === null || detail === void 0 ? void 0 : detail.checked);
        });
        this.addEventListener(events_1.appEvents.frontChatAudioRecord, (e) => {
            this.audioRecordingToggled(e.detail.isRecording);
        });
        this.addEventListener('chat_settings:submit', (e) => {
            const theEvent = e;
            this.chatSettings = theEvent.detail;
        });
        this.addEventListener('chat:remove:style', (e) => {
            this.handleWritingStyleRemoval(e);
        });
        this.chatService.getEventsService().subscribe('modelSynced', (data) => {
            this.$emit('modelSynced', data);
        });
        (_a = this.appChatSignal) === null || _a === void 0 ? void 0 : _a.value$.subscribe((value) => {
            if ((value === null || value === void 0 ? void 0 : value.command) === 'start-talk') {
                this.isTalking = true;
            }
            else if ((value === null || value === void 0 ? void 0 : value.command) === 'stop-talk') {
                this.conversationAgentService.stopPlayback();
                ChatAudioHelper_1.ChatAudioHelper.stopCurrentAudio();
                this.isTalking = false;
                this.autotalkSessionId = null;
                this.appChatSignal.setValue({ command: 'talk-ended' });
            }
            else if ((value === null || value === void 0 ? void 0 : value.command) === 'stop-all') {
                this.conversationAgentService.stopPlayback();
                ChatAudioHelper_1.ChatAudioHelper.stopCurrentAudio();
                this.isTalking = false;
                this.autotalkSessionId = null;
                this.appChatSignal.setValue({ command: 'talk-ended' });
                this.appChatSignal.setValue({ command: 'write-ended' });
            }
            if ((value === null || value === void 0 ? void 0 : value.command) === 'pause-talk') {
                this.conversationAgentService.pausePlayback();
                ChatAudioHelper_1.ChatAudioHelper.pauseCurrentAudio();
            }
            if ((value === null || value === void 0 ? void 0 : value.command) === 'resume-talk') {
                this.conversationAgentService.resumePlayback();
                ChatAudioHelper_1.ChatAudioHelper.resumeCurrentAudio();
            }
            if ((value === null || value === void 0 ? void 0 : value.command) === 'stop-chat') {
                this.isTalking = false;
                this.autotalkSessionId = null;
                const chatElement = this.getChatComponent();
                chatElement === null || chatElement === void 0 ? void 0 : chatElement.handleUserChatCancel();
                this.appChatSignal.setValue(null);
            }
            if ((value === null || value === void 0 ? void 0 : value.command) === 'setup-chat') {
                const params = value === null || value === void 0 ? void 0 : value.params;
                if (params) {
                    const volume = params.volume;
                    if (typeof volume === 'number') {
                        this.conversationAgentService.setVolume(volume);
                        this.chatService.getAudioService().setVolume(volume);
                        ChatAudioHelper_1.ChatAudioHelper.setVolume(volume);
                    }
                    if (params.voice) {
                        this.chatSettings = { ...this.chatSettings, voice: params.voice };
                        this.storageService.set('ai.chatSettings', JSON.stringify(this.chatSettings));
                    }
                }
            }
        });
        this.addEventListener('chat:speak', async (event) => {
            const message = event.detail;
            this.playAudioFromText(message.message);
        });
        this.addEventListener('chat:download', async (event) => {
            const message = event.detail;
            this.downloadAudioFromText(message.message);
        });
        this.addEventListener('autotalk:toggle', (e) => {
            const detail = e.detail;
            this.autoTalkEnabled = detail;
        });
        this.addEventListener('autotalk:start-session', async (e) => {
            console.log('catchedSession');
            try {
                const sessionId = await new Promise(async (resolve, reject) => {
                    var _a, _b, _c, _d, _e, _f;
                    this.wsAudioService.listenForMessage('conversation_agent', (e) => {
                        resolve(e.data.sessionId);
                    }, conversation_agent_events_1.CONVERSATION_AGENT_EVENTS.CONVERSATION_AGENT_STARTED, true);
                    const request = {
                        model: ((_b = (_a = this.selectedModel) === null || _a === void 0 ? void 0 : _a.model) === null || _b === void 0 ? void 0 : _b.value) || null,
                        avatarId: ((_d = (_c = this.selectedAvatar) === null || _c === void 0 ? void 0 : _c.id) === null || _d === void 0 ? void 0 : _d.toString()) || null,
                        chatSettings: this.chatSettings,
                        language: (0, translations_1.getLanguage)(),
                        knowledgeIds: this.knowledge,
                        writingStyleIds: this.writingStyles,
                        conversationId: ((_e = this.conversationId) === null || _e === void 0 ? void 0 : _e.toString()) || null,
                        voiceId: this.selectedAvatar ? this.selectedAvatar.voice : (((_f = this.chatSettings) === null || _f === void 0 ? void 0 : _f.voice) || null)
                    };
                    const callbacks = {
                        onError: (error) => {
                            console.error('❌ [AutoTalk] Session error:', error);
                            reject(error);
                        }
                    };
                    await this.conversationAgentService.startTextReadSession(request, callbacks);
                }); // Wait briefly to ensure session ID is set
                console.log('✅ [AutoTalk] Session ID obtained:', sessionId);
                this.autotalkSessionId = sessionId;
                console.log('✅ [AutoTalk] Session started:', sessionId);
            }
            catch (error) {
                console.error('❌ [AutoTalk] Failed to start session:', error);
            }
        });
        this.addEventListener('autotalk:stream-chunk', async (e) => {
            var _a;
            const detail = e.detail;
            let sessionId = this.autotalkSessionId;
            if (!sessionId) {
                console.error('❌ [AutoTalk] No session ID available for stream chunk');
                return;
            }
            if (!detail.chunk) {
                return;
            }
            try {
                if (!this.isTalking) {
                    (_a = this.appChatSignal) === null || _a === void 0 ? void 0 : _a.setValue({ command: 'start-talk' });
                    this.isTalking = true;
                }
                await this.conversationAgentService.streamTextChunkToAudio(sessionId, detail.chunk, detail.isFinal || false);
                if (detail.isFinal) {
                    console.log('✅ [AutoTalk] Final chunk streamed for session:', sessionId);
                    this.autotalkSessionId = null; // Clear the session ID after the final chunk is streamed
                    this.isTalking = false;
                }
            }
            catch (error) {
                console.error('❌ [AutoTalk] Failed to stream chunk:', error);
            }
        });
        this.addEventListener('live-chat:message-added', async (event) => {
            const rawMessage = event.detail.data.message;
            // Convert raw message to IFrontChatComponentMessage format
            const message = {
                id: rawMessage.id,
                text: [{ value: rawMessage.content }],
                isUserMessage: rawMessage.role === 'user',
                timestamp: rawMessage.timestamp instanceof Date ? rawMessage.timestamp.toISOString() : rawMessage.timestamp.toString(),
                rawContent: rawMessage.content,
                user: {
                    id: component_1.DefaultLayout.USER.id.toString(),
                    username: component_1.DefaultLayout.USER.username,
                    name: component_1.DefaultLayout.USER.name,
                    last_name: component_1.DefaultLayout.USER.last_name,
                    profile_pic: component_1.DefaultLayout.USER.profile_pic
                }
            };
            this.injectMsg(message);
        });
        this.addEventListener('big_file:confirm:kdb', async (event) => {
            const filePayload = event.detail.payload;
            const fileName = filePayload.originalName || filePayload.title;
            const fileSize = ChatEventsHelper.formatFileSize(filePayload.size);
            // Show confirmation dialog
            const confirmMessage = `file.upload.confirm.add_to_knowledge`.t()
                .replace('{fileName}', fileName)
                .replace('{fileSize}', fileSize);
            try {
                const confirmed = await this.popupService.confirm(confirmMessage);
                if (confirmed && this.knowledgePickerSignal) {
                    // User confirmed, send to knowledge picker signal
                    this.knowledgePickerSignal.setValue({
                        command: 'create',
                        createPayload: filePayload
                    });
                }
            }
            catch (error) {
                // Error showing confirmation dialog
            }
        }); // Handle request cancellation from LIT chat component
        this.addEventListener('chat:cancel-request', async (event) => {
            const requestId = event.detail.requestId;
            if (!requestId) {
                return;
            }
            try {
                const response = await this.apiService.back.post('ai.cancel-request', { requestId });
            }
            catch (error) {
                // Error cancelling request
            }
        });
        this.addEventListener('chat-component-connected', () => {
            // this.syncObservablesFromService();
        });
        this.addEventListener('chat:stop-talking', () => {
            var _a;
            (_a = this.appChatSignal) === null || _a === void 0 ? void 0 : _a.setValue({ command: 'stop-talk' });
        });
        window.addEventListener('ai-chat:tool:added', (e) => {
            console.log({ e });
            const theEvent = e;
            this.updateToolData(theEvent.detail.toolName, theEvent.detail.values);
            if (theEvent.detail.toolName == 'ai-form') {
                setTimeout(() => {
                    this.appendInputTextToChat('tools.aiFormAnalyzer.formSentByUser'.t(), true, true);
                    setTimeout(() => {
                        this.removeToolData(theEvent.detail.toolName);
                    }, 500);
                }, 500);
            }
        });
    }
    static sync() {
        if (!this.chatService || !this.chatService.getStateService()) {
            return;
        }
        const stateService = this.chatService.getStateService();
        this.conversation = stateService.conversation;
        if (stateService.selectedModel) {
            this.selectedModel = stateService.selectedModel;
        }
        if (stateService.selectedAIProvider) {
            this.selectedAIProvider = stateService.selectedAIProvider;
        }
        // this.selectedAvatar = stateService.selectedAvatar; // TODO: Fix this when state service supports IAvatar objects
        this.knowledge = stateService.knowledge;
        this.fullscan = stateService.fullscan;
        this.injectedMessages = stateService.injectedMessages;
        this.webSearchEnabled = stateService.webSearchEnabled;
        this.deepSearchEnabled = stateService.deepSearchEnabled;
        this.overrides = this.chatService.getConfigService().getOverrides();
    }
    initOverrides() {
        var _a, _b;
        this.chatService.getConfigService().updateOverrides({
            selectedModel: this.selectedModel,
            aiProvider: this.selectedAIProvider,
            avatar: ((_b = (_a = this.selectedAvatar) === null || _a === void 0 ? void 0 : _a.id) === null || _b === void 0 ? void 0 : _b.toString()) || null,
            language: (0, translations_1.getLanguage)(),
            userId: component_1.DefaultLayout.USER.id
        });
    }
    static formatFileSize(bytes) {
        if (bytes === 0)
            return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }
}
exports.ChatEventsHelper = ChatEventsHelper;
